import React from 'react';
import {  Route, Routes } from 'react-router';
import { routes } from './constants';



const AppRoutes = () => {
    return (
        <Routes>
            {routes.map((route, index) => (
                <Route
                    key={index}
                    path={route.path}
                    element={
                        !route.isAuthenticated && 
                            <route.component />
        
                    }
                />
            ))}
        </Routes>
    );
};

export default AppRoutes;